import React from 'react';

import './AgentLogModal.css';
import { useGetAgentLogsQuery } from '../store/services/planningRuntimeApi';

import { AgentLogTable } from './AgentLogTable';

interface AgentLogModalProps {
  isOpen: boolean;
  onClose: () => void;
  projectId: string;
}

export const AgentLogModal: React.FC<AgentLogModalProps> = ({ isOpen, onClose, projectId }) => {
  const { currentData: logs = [], error } = useGetAgentLogsQuery(
    projectId,
    { skip: !isOpen || !projectId },
  );

  if (!isOpen) return null;

  return (
    <div className="agent-log-modal-overlay" onClick={onClose} role="button" tabIndex={0} onKeyDown={onClose}>
      <div
        className="agent-log-modal-content"
        onClick={(e) => e.stopPropagation()}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div className="agent-log-modal-header">
          <h2>Agent Activity Logs</h2>
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="agent-log-modal-body">
          {error ? <div role="alert">We couldn&apos;t load the agent activity. Check your connection and try again.</div> : <AgentLogTable logs={logs} />}
        </div>
      </div>
    </div>
  );
};
